import PropTypes from "prop-types";
import Card from "react-bootstrap/Card";

import OutboundLink from "components/OutboundLink";
import useCanRunAds from "hooks/useCanRunAds";

import styles from "./PleaseSupportUs.module.scss";

const PleaseSupportUs = ({ always, height, width }) => {
  const canRunAds = useCanRunAds();

  if (canRunAds && !always) {
    return null;
  }

  return (
    <Card className="shadow-sm">
      <div
        className={styles.container}
        style={{
          height: height || 200,
          width: width || "auto",
        }}
      >
        <OutboundLink url="https://patreon.com/edhrec" utm_medium="please_support_us">
          Please consider supporting us on Patreon to remove ads for only $2/month.
        </OutboundLink>
      </div>
    </Card>
  );
};

PleaseSupportUs.propTypes = {
  always: PropTypes.bool,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default PleaseSupportUs;
